export default "__VITE_ASSET__cb6f6106__"